import { useState } from 'react';

import { Grid } from '@mui/material';

import { CissTextField } from 'components/fields';
import { Filter } from 'components/filter';
import { FilterValuesProps } from 'hooks/useFilter';

export function FormFilterCentroCusto() {
    const [filterIdCentroCusto, seFilterIdCentroCusto] = useState<FilterValuesProps>({
        property: 'idCentroCusto',
        operator: 'like',
        value: null,
        idProperty: 'idCentroCusto',
    });
    const [filterDsCentroCusto, setFilterDsCentroCusto] = useState<FilterValuesProps>({
        property: 'dsCentroCusto',
        operator: 'like',
        value: null,
        idProperty: 'dsCentroCusto',
    });
    const [filterCdCentroCusto, setFilterCdCentroCusto] = useState<FilterValuesProps>({
        property: 'cdCentroCusto',
        operator: 'like',
        value: null,
        idProperty: 'cdCentroCusto',
    });

    const [fgAtivo, setFgAtivo] = useState<FilterValuesProps>({
        property: 'fgAtivo',
        operator: 'eq',
        value: null,
        idProperty: 'fgAtivo',
    });
    return (
        <Filter
            preventQueryParamsEmptyStart
            filters={[
                { value: filterIdCentroCusto, setter: seFilterIdCentroCusto },
                { value: filterDsCentroCusto, setter: setFilterDsCentroCusto },
                { value: filterCdCentroCusto, setter: setFilterCdCentroCusto },
                { value: fgAtivo, setter: setFgAtivo },
            ]}
        >
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Código"
                    value={filterIdCentroCusto.value}
                    style={{ marginBottom: 20 }}
                    onChange={(e) => seFilterIdCentroCusto((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Nome do centro"
                    value={filterDsCentroCusto.value}
                    onChange={(e) => setFilterDsCentroCusto((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
            <Grid sx={{ flex: 4 }}>
                <CissTextField
                    label="Código de Integração"
                    value={filterCdCentroCusto.value}
                    onChange={(e) => setFilterCdCentroCusto((oldState: FilterValuesProps) => ({ ...oldState, value: e.target.value }))}
                />
            </Grid>
        </Filter>
    );
}
